import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { PubTopbarComponent } from '../../template/pub-topbar/pub-topbar.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthenticationManagerComponent } from '../../global/authentication-manager/authentication-manager.component';
import { CustomLoadingPanelComponent, CustomAlertComponent, LocalService, AuthService, AlertService } from 'lib-base';
import { TramRegistroSolicitudService } from '../../../services/tramiteRegistroSolicitud.service';
import { firstValueFrom, forkJoin, Subscription } from 'rxjs';
import {FooterComponent} from "../../template/footer/footer.component";

@Component({
  selector: 'app-public-layout',
  standalone: true,
  imports: [RouterOutlet, ToastModule, TranslateModule,
    PubTopbarComponent, AuthenticationManagerComponent,
    CustomLoadingPanelComponent, CustomAlertComponent, FooterComponent
  ],
  templateUrl: './public-layout.component.html',
  styleUrl: './public-layout.component.scss'
})
export class PublicLayoutComponent implements OnInit, OnDestroy {

  trans: any = {};
  private _hideDialog !: Subscription;

  constructor(
    private readonly _ls: LocalService,
    private readonly _auth: AuthService,
    private readonly _trss: TramRegistroSolicitudService,
    private readonly _as: AlertService,
    private readonly _t: TranslateService,
    private readonly _router: Router
  ) {
    this.checkAuthentication();
  }

  ngOnInit(): void {
    this.translate();
  }

  ngOnDestroy(): void {
    if (this._hideDialog) {
      this._hideDialog.unsubscribe();
    }
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      tramitePendiente: this._t.get('msg.tramitePendiente'),
      tareaPendiente: this._t.get('msg.tareaPendiente'),
      continuar: this._t.get('common.continuar')
    }));
  }

  checkAuthentication() {
    //Revisa si el refresh token ha expirado y si es así, cierra la sesión
    if (this._ls.isLoggedIn) {
      if (this._ls.isRefreshCookieExpired) {
        this._auth.logout().subscribe({ next: (response) => { } });
      }
    }
  }
}
